import {
  createQueryString,
  removeCookieValue,
  setCookieValue,
} from "@/app/utils/utility";
import apiInstance from "../../api-config/axios-instance";

export async function signInUser(payload) {
  const { userCreds, userType = "Personal", setServerErrorMsg } = payload;
  const { email, password } = userCreds;

  try {
    const response = await apiInstance.post(`/login?userType=${userType}`, {
      email,
      password,
    });
    setServerErrorMsg("");
    return response;
  } catch (error) {
    console.log("error", error);
    if (error.status == 428) {
      setCookieValue("userID", error?.data?.userId);
    } else {
      removeCookieValue("userID");
    }
    const errorMessage =
      error?.response?.data?.message ||
      error?.data?.message ||
      "An unexpected error occurred";
    setServerErrorMsg(errorMessage);
    throw new Error(errorMessage); // Throw the error message for onError
  }
}

export async function signUpUser(payload) {
  const { userDetails, userType = "Personal", setServerErrorMsg } = payload;
  const { firstName, lastName, email, password, phone, ...rest } = userDetails;

  try {
    const response = await apiInstance.post(`/signup?userType=${userType}`, {
      firstName,
      lastName,
      email,
      phone,
      password,
      ...rest,
    });
    return response;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.data?.message ||
      "An unexpected error occurred";
    setServerErrorMsg(errorMessage.message || errorMessage);
    throw new Error(errorMessage); // Throw the error message for onError
  }
}

export function forgotPasswordAdmin(payload) {
  const { email } = payload;
  const response = apiInstance.post("/adminforgetpassword", { email });
  return response;
}
// function to request for forgotpassword
export async function forgotPassword(payload) {
  const { email, userType, setServerErrorMsg } = payload;
  try {
    const response = await apiInstance.post(
      `/forgetpassword?userType=${userType}`,
      { email }
    );
    console.log(response, "response");

    return response;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.data?.message ||
      "An unexpected error occurred";
    setServerErrorMsg(errorMessage.message || errorMessage);
    throw new Error(errorMessage); // Throw the error message for onError
  }
}

export function resetPassword(payload) {
  const { email, password, otp } = payload;
  const response = apiInstance.put("/adminresetpassword", {
    email,
    password,
    otp,
  });
  return response;
}

// check user role /userrolecheck

export function checkUserType(payload) {
  const { email } = payload;
  const response = apiInstance.get(`/userrolecheck?email=${email}`);
  return response;
}

// function to verify user
export const verifyUser = async (payload) => {
  const {
    email,
    otp,
    userType = "Personal",
    verify_type,
    setServerErrorMsg,
  } = payload || {};
  const body = verify_type ? { email, otp, verify_type } : { email, otp };
  try {
    const response = await apiInstance.put(
      `/verifyemail?userType=${userType}`,
      body
    );
    return response;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.data?.message ||
      "An unexpected error occurred";
    setServerErrorMsg(errorMessage || errorMessage.message);
    throw new Error(errorMessage); // Throw the error message for onError
  }
};
// function to resend otp
export const resendOtp = async (payload) => {
  const { email, userType, verifyType, setServerErrorMsg } = payload;

  const body = verifyType ? { email, verifyType } : { email };
  console.log(body, "body");

  try {
    const response = await apiInstance.post(
      `/resendotp?userType=${userType}`,
      body
    );
    return response;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.data?.message ||
      "An unexpected error occurred";
    setServerErrorMsg(errorMessage.message || errorMessage);
    throw new Error(errorMessage); // Throw the error message for onError
  }
};

export async function resetUserPassword(payload) {
  const {
    password,
    userType = "Personal",
    otp,
    email,
    setServerErrorMsg,
  } = payload;
  try {
    const response = await apiInstance.put(
      `/resetpassword?userType=${userType}`,
      {
        password,
        otp,
        email,
      }
    );
    return response;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.data?.message ||
      "An unexpected error occurred";
    setServerErrorMsg(errorMessage.message || errorMessage);
    throw new Error(errorMessage); // Throw the error message for onError
  }
}

// create subscribtion
export const addSubscribtion = async (payload) => {
  try {
    const resposne = await apiInstance.post(
      `/subscribeEmail/subscribe`,
      payload,
      {
        skipLoader: true,
      }
    );

    if (resposne.status === 200) {
      return {
        status: resposne.data.status,
        data: [],
        message: resposne.data.message,
      };
    } else {
      return { status: false, data: [], message: "Test" };
    }
  } catch (err) {
    return { status: false, data: [], message: err.message };
  }
};

// fetch the list of subscribtion
export const getSubscribedEmailsList = async (payload) => {
  try {
    const resposne = await apiInstance.get(
      `/subscribeEmail/get${createQueryString(payload)}`,
      {
        skipLoader: true,
      }
    );
    if (resposne?.data?.success) {
      return {
        status: true,
        data: resposne.data || [],
      };
    } else {
      return { status: false, data: [] };
    }
  } catch (err) {
    return { status: false, data: [] };
  }
};
